import { App, FEVorvertragsnummer, TaasInfo, Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { Role, Tarifbereich, Vermittlernummer, Zahlungsart } from '@ps20/bff-models';
import { AngebotsId } from './angebotsId';

export interface WrappedSavedStatesLoaded {
  savedStatesLoaded: WrappedSavedStates;
  savedSensitiveStatesLoaded?: SavedState;
}

export type WrappedSavedStates = SavedStateWrapper[];

export interface SavedStateWrapper extends AngebotsId {
  state: SavedState;
}

export interface SavedState {
  version: number;
  angebotsId?: string;
  versicherungsnehmer?: Versicherungsnehmer;
  risikoort?: Adresse;
  accountManager?: Vermittlernummer;
  vertragsoptionen?: Vertragsoptionen;
  unfAngaben?: {
    vpAngabenListe: VpAngaben[];
  };
  [key: string]: unknown;
  zahlungsoptionen?: Zahlungsoptionen;
  zahlung?: Zahlungsoptionen;
  taasInfo?: TaasInfo;
  produkte?: LoadedCheckoutProdukt[];
  vorversicherungen?: Vorversicherung[];
  role?: Role;
}

export interface UploadedFile {
  uploadId: string;
}

export interface VpAngaben {
  angebotsId: AngebotsId['angebotsId'];
  pflegeFrageAntwort?: boolean;
  hasBeeintraechtigungen?: boolean;
  beeintraechtigungen?: string;
}

export interface Versicherungsnehmer {
  geburtsdatum?: string;
  adresse?: Adresse;
  isFinanzdienstleistertarif?: boolean;
  isAssekuranztarif?: boolean;
  tarifbereich?: Tarifbereich;
  currentRole?: VnRoleEnum;
  selectedRole?: VnRoleEnum;
  vorbelegteRole?: VnRoleEnum;
}

export interface Adresse {
  strasse?: string;
  hausnummer?: string;
  plz?: string;
  ort?: string;
  hausnrzus?: string;
}

export enum VnRoleEnum {
  MITARBEITER = 'mitarbeiter',
  SONSTIGE = 'sonstige',
  KEIN = 'kein',
}

export interface Zahlungsoptionen {
  zahlungsart?: Zahlungsart;
}

export interface LoadedCheckoutProdukt extends AngebotsId {
  appId: App;
  angebotsId?: string;
  beibehalten?: boolean;
  vorvertragsnummer?: FEVorvertragsnummer[];
  einbruchMeldeanlage?: FilesOwner;
  mechanischeSicherungen?: FilesOwner;
  tresor?: TresorEintrag;
}

export interface FilesOwner {
  files?: UploadedFile[];
}

export interface TresorEintrag {
  files?: UploadedFile[];
}

export function deleteVersicherungsnehmerExceptisFinanzdienstleister(
  versicherungsnehmer: Versicherungsnehmer,
): void {
  Object.keys(versicherungsnehmer).forEach(element => {
    if (
      element !== 'isFinanzdienstleistertarif' &&
      element !== 'isAssekuranztarif' &&
      element !== 'tarifbereich' &&
      element !== 'currentRole' &&
      element !== 'selectedRole' &&
      element !== 'vorbelegteRole'
    ) {
      delete (versicherungsnehmer as Record<string, unknown>)[element];
    }
  });
}

export interface Vorversicherung extends AngebotsId {
  vorhanden: boolean;
}
